(() => {
  const guide = document.getElementById('bbq-method-guide');
  if (!guide || guide.dataset.ready) return;
  guide.dataset.ready = 'true';
  const filters = guide.querySelector('.mg-filters');
  const cards = [...guide.querySelectorAll('[data-matches]')];
  const count = guide.querySelector('[data-guide-count]');
  const update = (food) => {
    let shown = 0;
    cards.forEach(card => {
      card.hidden = food !== 'all' && !card.dataset.matches.split('|').includes(food);
      if (!card.hidden) shown++;
    });
    filters.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.food === food)));
    count.textContent = food === 'all' ? shown + ' rubs to explore' : shown + ' rubs for ' + food;
  };
  filters.hidden = false;
  filters.addEventListener('click', event => {
    const button = event.target.closest('button[data-food]');
    if (button) update(button.dataset.food);
  });
  update('all');
})();
